import { createContext } from 'react';

export type ProgressGroupContextType = {
  showLabel: boolean;
  graduations: number;
  minimal?: boolean;
  stacked: boolean;
};
export const ProgressGroupContext = createContext<ProgressGroupContextType>({
  showLabel: true,
  graduations: 0,
  minimal: false,
  stacked: false,
});
